import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -300px;
`;

const Text = styled.p`
  font-size: 22px;
  font-weight: 700;
  font-family: 'Geomanist';
`;

const PermissionMessage = () => {
  return (
    <Container>
      <Text>
        Sorry, you don't have the necessary permissions to access this feature.{' '}
      </Text>
    </Container>
  );
};

export default PermissionMessage;



// WEBPACK FOOTER //
// ./src/components/Dashboard/PermissionMessage/index.jsx